import {Box, Grid, Typography} from "@mui/material";
import {PlusShield} from "@vectopus/atlas-icons-react";
import React from "react";
import {useTranslation} from "react-i18next";
import {hunify} from "../utils/helpers";

const AssuranceIncluded = () => {

  const {t} = useTranslation();

  return (
    <Box mt={4}>
      <Grid
        container
        direction={'row'}
        alignItems={'flex-start'}
        justifyContent={'flex-start'}
      >
        <Grid item xs={1}>
          <PlusShield size={28} />
        </Grid>
        <Grid item xs={9} textAlign={'left'}>
          <Typography
            variant={'h4'}
            component={'h4'}
            dangerouslySetInnerHTML={hunify(t('Assicurazione hu cover'))}>
          </Typography>
          <Typography variant={'body2'} component={'small'} sx={{ fontSize: 12 }}>
            {t('Inclusa_nel_prezzo')}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Box sx={{ backgroundColor: '#D4F15F', width: '100%', textAlign: 'center' }}>
            <Typography variant={'body1'} component={'h5'} sx={{fontSize: 12, textTransform: 'uppercase'}}>
              {t('free')}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AssuranceIncluded;
